const LIST_SPECIALTY_CODE = [{ 'id': '102L00000X', 'name': 'Psychoanalyst' }, {
  'id': '1223X0008X',
  'name': 'Dentist, Oral and Maxillofacial Radiology'
}, { 'id': '133V00000X', 'name': 'Dietitian, Registered' }, {
  'id': '171000000X',
  'name': 'Military Health Care Provider'
}, { 'id': '1710I1002X', 'name': 'Military Health Care Provider, Independent Duty Corpsman' }, {
  'id': '1710I1003X',
  'name': 'Military Health Care Provider, Independent Duty Medical Technicians'
}, { 'id': '173000000X', 'name': 'Legal Medicine' }, {
  'id': '204D00000X',
  'name': 'Neuromusculoskeletal Medicine & OMM'
}, { 'id': '204F00000X', 'name': 'Transplant Surgery' }, {
  'id': '207K00000X',
  'name': 'Allergy & Immunology'
}, { 'id': '207KA0200X', 'name': 'Allergy & Immunology, Allergy' }, {
  'id': '207KI0005X',
  'name': 'Allergy & Immunology, Clinical & Laboratory Immunology'
}, { 'id': '207L00000X', 'name': 'Anesthesiology' }, {
  'id': '207LC0200X',
  'name': 'Anesthesiology, Critical Care Medicine'
}, { 'id': '207LP2900X', 'name': 'Anesthesiology, Pain Medicine' }, {
  'id': '207N00000X',
  'name': 'Dermatology'
}, { 'id': '207ND0900X', 'name': 'Dermatology, Dermatopathology' }, {
  'id': '207NI0002X',
  'name': 'Dermatology, Clinical & Laboratory Dermatological Immunology'
}, { 'id': '207NS0135X', 'name': 'Dermatology, Procedural Dermatology' }, {
  'id': '207P00000X',
  'name': 'Emergency Medicine'
}, { 'id': '207PP0204X', 'name': 'Emergency Medicine, Pediatric Emergency Medicine' }, {
  'id': '207PS0010X',
  'name': 'Emergency Medicine, Sports Medicine'
}, { 'id': '207PT0002X', 'name': 'Emergency Medicine, Medical Toxicology' }, {
  'id': '207Q00000X',
  'name': 'Family Medicine'
}, { 'id': '207QA0000X', 'name': 'Family Medicine, Adolescent Medicine' }, {
  'id': '207QA0401X',
  'name': 'Family Medicine, Addiction Medicine'
}, { 'id': '207QG0300X', 'name': 'Family Medicine, Geriatric Medicine' }, {
  'id': '207QS0010X',
  'name': 'Family Medicine, Sports Medicine'
}, { 'id': '207R00000X', 'name': 'Internal Medicine' }, {
  'id': '207RC0000X',
  'name': 'Internal Medicine, Cardiovascular Disease'
}, { 'id': '207RC0001X', 'name': 'Internal Medicine, Clinical Cardiac Electrophysiology' }, {
  'id': '207RC0200X',
  'name': 'Internal Medicine, Critical Care Medicine'
}, { 'id': '207RE0101X', 'name': 'Internal Medicine, Endocrinology, Diabetes & Metabolism' }, {
  'id': '207RG0100X',
  'name': 'Internal Medicine, Gastroenterology'
}, { 'id': '207RG0300X', 'name': 'Internal Medicine, Geriatric Medicine' }, {
  'id': '207RH0002X',
  'name': 'Internal Medicine, Hospice and Palliative Medicine'
}, { 'id': '207RH0003X', 'name': 'Internal Medicine, Hematology & Oncology' }, {
  'id': '207RI0008X',
  'name': 'Internal Medicine, Hepatology'
}, { 'id': '207RI0200X', 'name': 'Internal Medicine, Infectious Disease' }, {
  'id': '207RN0300X',
  'name': 'Internal Medicine, Nephrology'
}, { 'id': '207RP1001X', 'name': 'Internal Medicine, Pulmonary Disease' }, {
  'id': '207RR0500X',
  'name': 'Internal Medicine, Rheumatology'
}, { 'id': '207RS0010X', 'name': 'Internal Medicine, Sports Medicine' }, {
  'id': '207RX0202X',
  'name': 'Internal Medicine, Medical Oncology'
}, { 'id': '207SC0300X', 'name': 'Medical Genetics, Clinical Cytogenetics' }, {
  'id': '207SG0201X',
  'name': 'Medical Genetics, Clinical Genetics (M.D.)'
}, { 'id': '207SG0203X', 'name': 'Medical Genetics, Clinical Molecular Genetics' }, {
  'id': '207SG0205X',
  'name': 'Medical Genetics, Ph.D. Medical Genetics'
}, { 'id': '207T00000X', 'name': 'Neurological Surgery' }, {
  'id': '207UN0902X',
  'name': 'Nuclear Medicine, Nuclear Imaging & Therapy'
}, { 'id': '207V00000X', 'name': 'Obstetrics & Gynecology' }, {
  'id': '207VC0200X',
  'name': 'Obstetrics & Gynecology, Critical Care Medicine'
}, { 'id': '207VE0102X', 'name': 'Obstetrics & Gynecology, Reproductive Endocrinology' }, {
  'id': '207VG0400X',
  'name': 'Obstetrics & Gynecology, Gynecology'
}, { 'id': '207VM0101X', 'name': 'Obstetrics & Gynecology, Maternal & Fetal Medicine' }, {
  'id': '207VX0000X',
  'name': 'Obstetrics & Gynecology, Obstetrics'
}, { 'id': '207W00000X', 'name': 'Ophthalmology' }, {
  'id': '207X00000X',
  'name': 'Orthopaedic Surgery'
}, { 'id': '207XP3100X', 'name': 'Orthopaedic Surgery, Pediatric Orthopaedic Surgery' }, {
  'id': '207XS0114X',
  'name': 'Orthopaedic Surgery, Adult Reconstructive Orthopaedic Surgery'
}, { 'id': '207XX0004X', 'name': 'Orthopaedic Surgery, Foot and Ankle Surgery' }, {
  'id': '207XX0005X',
  'name': 'Orthopaedic Surgery, Sports Medicine'
}, { 'id': '207Y00000X', 'name': 'Otolaryngology' }, {
  'id': '207YP0228X',
  'name': 'Otolaryngology, Pediatric Otolaryngology'
}, { 'id': '207YX0901X', 'name': 'Otolaryngology, Otology & Neurotology' }, {
  'id': '207ZB0001X',
  'name': 'Pathology, Blood Banking & Transfusion Medicine'
}, { 'id': '207ZC0500X', 'name': 'Pathology, Cytopathology' }, {
  'id': '207ZF0201X',
  'name': 'Pathology, Forensic Pathology'
}, { 'id': '207ZH0000X', 'name': 'Pathology, Hematology' }, {
  'id': '207ZN0500X',
  'name': 'Pathology, Neuropathology'
}, { 'id': '207ZP0101X', 'name': 'Pathology, Anatomic Pathology' }, {
  'id': '207ZP0104X',
  'name': 'Pathology, Chemical Pathology'
}, { 'id': '207ZP0213X', 'name': 'Pathology, Pediatric Pathology' }, {
  'id': '208000000X',
  'name': 'Pediatrics'
}, { 'id': '2080A0000X', 'name': 'Pediatrics, Adolescent Medicine' }, {
  'id': '2080I0007X',
  'name': 'Pediatrics, Clinical & Laboratory Immunology'
}, { 'id': '2080N0001X', 'name': 'Pediatrics, Neonatal-Perinatal Medicine' }, {
  'id': '2080P0202X',
  'name': 'Pediatrics, Pediatric Cardiology'
}, { 'id': '2080P0203X', 'name': 'Pediatrics, Pediatric Critical Care Medicine' }, {
  'id': '2080P0204X',
  'name': 'Pediatrics, Pediatric Emergency Medicine'
}, { 'id': '2080P0206X', 'name': 'Pediatrics, Pediatric Gastroenterology' }, {
  'id': '2080P0207X',
  'name': 'Pediatrics, Pediatric Hematology-Oncology'
}, { 'id': '2080P0208X', 'name': 'Pediatrics, Pediatric Infectious Diseases' }, {
  'id': '2080P0216X',
  'name': 'Pediatrics, Pediatric Rheumatology'
}, { 'id': '2080S0010X', 'name': 'Pediatrics, Sports Medicine' }, {
  'id': '2080T0002X',
  'name': 'Pediatrics, Medical Toxicology'
}, { 'id': '208100000X', 'name': 'Physical Medicine & Rehabilitation' }, {
  'id': '208200000X',
  'name': 'Plastic Surgery'
}, { 'id': '2082S0099X', 'name': 'Plastic Surgery, Plastic Surgery Within the Head and Neck' }, {
  'id': '2083A0100X',
  'name': 'Preventive Medicine, Aerospace Medicine'
}, {
  'id': '2083P0901X',
  'name': 'Preventive Medicine, Public Health & General Preventive Medicine'
}, { 'id': '2083X0100X', 'name': 'Preventive Medicine, Occupational Medicine' }, {
  'id': '2084F0202X',
  'name': 'Psychiatry & Neurology, Forensic Psychiatry'
}, {
  'id': '2084N0402X',
  'name': 'Psychiatry & Neurology, Neurology with Special Qualifications in Child Neurology'
}, { 'id': '2084P0800X', 'name': 'Psychiatry & Neurology, Psychiatry' }, {
  'id': '2084P0805X',
  'name': 'Psychiatry & Neurology, Geriatric Psychiatry'
}, { 'id': '2084S0012X', 'name': 'Psychiatry & Neurology, Sleep Medicine' }, {
  'id': '2085B0100X',
  'name': 'Radiology, Body Imaging'
}, { 'id': '2085N0904X', 'name': 'Radiology, Nuclear Radiology' }, {
  'id': '2085P0229X',
  'name': 'Radiology, Pediatric Radiology'
}, { 'id': '2085R0202X', 'name': 'Radiology, Diagnostic Radiology' }, {
  'id': '2085R0204X',
  'name': 'Radiology, Vascular & Interventional Radiology'
}, { 'id': '2085R0205X', 'name': 'Radiology, Radiological Physics' }, {
  'id': '208600000X',
  'name': 'Surgery'
}, { 'id': '2086S0105X', 'name': 'Surgery, Surgery of the Hand' }, {
  'id': '2086S0120X',
  'name': 'Surgery, Pediatric Surgery'
}, { 'id': '2086S0127X', 'name': 'Surgery, Trauma Surgery' }, {
  'id': '2086S0129X',
  'name': 'Surgery, Vascular Surgery'
}, { 'id': '208800000X', 'name': 'Urology' }, {
  'id': '2088P0231X',
  'name': 'Urology, Pediatric Urology'
}, { 'id': '208C00000X', 'name': 'Colon & Rectal Surgery' }, {
  'id': '208D00000X',
  'name': 'General Practice'
}, { 'id': '208G00000X', 'name': 'Thoracic Surgery (Cardiothoracic Vascular Surgery)' }, {
  'id': '208U00000X',
  'name': 'Clinical Pharmacology'
}, { 'id': '208VP0000X', 'name': 'Pain Medicine, Pain Medicine' }, {
  'id': '246R00000X',
  'name': 'Technician, Pathology'
}, { 'id': '246Z00000X', 'name': 'Specialist/Technologist, Other' }, {
  'id': '320600000X',
  'name': 'Residential Treatment Facility, Mental Retardation and/or Developmental Disabilities'
}, { 'id': '320700000X', 'name': 'Residential Treatment Facility, Physical Disabilities' }, {
  'id': '324500000X',
  'name': 'Substance Abuse Rehabilitation Facility'
}, {
  'id': '3245S0500X',
  'name': 'Substance Abuse Rehabilitation Facility, Substance Abuse Treatment, Children'
}, { 'id': '385H00000X', 'name': 'Respite Care' }, {
  'id': '385HR2050X',
  'name': 'Respite Care, Respite Care Camp'
}, { 'id': '385HR2055X', 'name': 'Respite Care, Respite Care, Mental Illness, Child' }, {
  'id': '385HR2060X',
  'name': 'Respite Care, Respite Care, Mental Retardation and/or Developmental Disabilities'
}, { 'id': '385HR2065X', 'name': 'Respite Care, Respite Care, Physical Disabilities, Child' }, {
  'id': '331L00000X',
  'name': 'Blood Bank'
}, { 'id': '332100000X', 'name': 'Department of Veterans Affairs (VA) Pharmacy' }, {
  'id': '332B00000X',
  'name': 'Durable Medical Equipment & Medical Supplies'
}, {
  'id': '332BC3200X',
  'name': 'Durable Medical Equipment & Medical Supplies, Customized Equipment'
}, {
  'id': '332BD1200X',
  'name': 'Durable Medical Equipment & Medical Supplies, Dialysis Equipment & Supplies'
}, {
  'id': '332BN1400X',
  'name': 'Durable Medical Equipment & Medical Supplies, Nursing Facility Supplies'
}, {
  'id': '332BX2000X',
  'name': 'Durable Medical Equipment & Medical Supplies, Oxygen Equipment & Supplies'
}, {
  'id': '332BP3500X',
  'name': 'Durable Medical Equipment & Medical Supplies, Parenteral & Enteral Nutrition'
}, { 'id': '333300000X', 'name': 'Emergency Response System Companies' }, {
  'id': '332G00000X',
  'name': 'Eye Bank'
}, { 'id': '332H00000X', 'name': 'Eyewear Supplier' }, {
  'id': '332S00000X',
  'name': 'Hearing Aid Equipment'
}, { 'id': '332U00000X', 'name': 'Home Delivered Meals' }, {
  'id': '332800000X',
  'name': 'Indian Health Service/Tribal/Urban Indian Health (I/T/U) Pharmacy'
}, { 'id': '332000000X', 'name': 'Military/U.S. Coast Guard Pharmacy' }, {
  'id': '332900000X',
  'name': 'Non-Pharmacy Dispensing Site'
}, { 'id': '335U00000X', 'name': 'Organ Procurement Organization' }, {
  'id': '333600000X',
  'name': 'Pharmacy'
}, { 'id': '3336C0002X', 'name': 'Pharmacy, Clinic Pharmacy' }, {
  'id': '3336C0003X',
  'name': 'Pharmacy, Community/Retail Pharmacy'
}, { 'id': '3336C0004X', 'name': 'Pharmacy, Compounding Pharmacy' }, {
  'id': '3336H0001X',
  'name': 'Pharmacy, Home Infusion Therapy Pharmacy'
}, { 'id': '3336I0012X', 'name': 'Pharmacy, Institutional Pharmacy' }, {
  'id': '3336L0003X',
  'name': 'Pharmacy, Long Term Care Pharmacy'
}, { 'id': '3336M0002X', 'name': 'Pharmacy, Mail Order Pharmacy' }, {
  'id': '3336M0003X',
  'name': 'Pharmacy, Managed Care Organization Pharmacy'
}, { 'id': '3336N0007X', 'name': 'Pharmacy, Nuclear Pharmacy' }, {
  'id': '3336S0011X',
  'name': 'Pharmacy, Specialty Pharmacy'
}, {
  'id': '335V00000X',
  'name': 'Portable X-ray and/or Other Portable Diagnostic Imaging Supplier'
}, { 'id': '335E00000X', 'name': 'Prosthetic/Orthotic Supplier' }, {
  'id': '344800000X',
  'name': 'Air Carrier'
}, { 'id': '341600000X', 'name': 'Ambulance' }, {
  'id': '3416A0800X',
  'name': 'Ambulance, Air Transport'
}, { 'id': '3416L0300X', 'name': 'Ambulance, Land Transport' }, {
  'id': '3416S0300X',
  'name': 'Ambulance, Water Transport'
}, { 'id': '347B00000X', 'name': 'Bus' }, {
  'id': '341800000X',
  'name': 'Military/U.S. Coast Guard Transport'
}, {
  'id': '3418M1120X',
  'name': 'Military/U.S. Coast Guard Transport, Military or U.S. Coast Guard Ambulance, Air Transport'
}, {
  'id': '3418M1110X',
  'name': 'Military/U.S. Coast Guard Transport, Military or U.S. Coast Guard Ambulance, Ground Transport'
}, {
  'id': '3418M1130X',
  'name': 'Military/U.S. Coast Guard Transport, Military or U.S. Coast Guard Ambulance, Water Transport'
}, { 'id': '343900000X', 'name': 'Non-emergency Medical Transport (VAN)' }, {
  'id': '347C00000X',
  'name': 'Private Vehicle'
}, { 'id': '343800000X', 'name': 'Secured Medical Transport (VAN)' }, {
  'id': '344600000X',
  'name': 'Taxi'
}, { 'id': '347D00000X', 'name': 'Train' }, {
  'id': '347E00000X',
  'name': 'Transportation Broker'
}, { 'id': '193200000X', 'name': 'Multi-Specialty' }, {
  'id': '193400000X',
  'name': 'Single Specialty'
}, { 'id': '207LA0401X', 'name': 'Anesthesiology, Addiction Medicine' }, {
  'id': '207LH0002X',
  'name': 'Anesthesiology, Hospice and Palliative Medicine'
}, { 'id': '207LP3000X', 'name': 'Anesthesiology, Pediatric Anesthesiology' }, {
  'id': '207ND0101X',
  'name': 'Dermatology, MOHS-Micrographic Surgery'
}, { 'id': '207NP0225X', 'name': 'Dermatology, Pediatric Dermatology' }, {
  'id': '204R00000X',
  'name': 'Electrodiagnostic Medicine'
}, { 'id': '207PE0004X', 'name': 'Emergency Medicine, Emergency Medical Services' }, {
  'id': '207PH0002X',
  'name': 'Emergency Medicine, Hospice and Palliative Medicine'
}, { 'id': '207PE0005X', 'name': 'Emergency Medicine, Undersea and Hyperbaric Medicine' }, {
  'id': '207QA0505X',
  'name': 'Family Medicine, Adult Medicine'
}, { 'id': '207QB0002X', 'name': 'Family Medicine, Obesity Medicine' }, {
  'id': '207QH0002X',
  'name': 'Family Medicine, Hospice and Palliative Medicine'
}, { 'id': '207QS1201X', 'name': 'Family Medicine, Sleep Medicine' }, {
  'id': '208M00000X',
  'name': 'Hospitalist'
}, { 'id': '202C00000X', 'name': 'Independent Medical Examiner' }, {
  'id': '207RA0401X',
  'name': 'Internal Medicine, Addiction Medicine'
}, { 'id': '207RA0000X', 'name': 'Internal Medicine, Adolescent Medicine' }, {
  'id': '207RA0201X',
  'name': 'Internal Medicine, Allergy & Immunology'
}, { 'id': '207RB0002X', 'name': 'Internal Medicine, Obesity Medicine' }, {
  'id': '207RI0001X',
  'name': 'Internal Medicine, Clinical & Laboratory Immunology'
}, { 'id': '207RI0011X', 'name': 'Internal Medicine, Interventional Cardiology' }, {
  'id': '207RM1200X',
  'name': 'Internal Medicine, Magnetic Resonance Imaging (MRI)'
}, { 'id': '207RS0012X', 'name': 'Internal Medicine, Sleep Medicine' }, {
  'id': '207RT0003X',
  'name': 'Internal Medicine, Transplant Hepatology'
}, { 'id': '209800000X', 'name': 'Legal Medicine' }, {
  'id': '207SG0202X',
  'name': 'Medical Genetics, Clinical Biochemical Genetics'
}, { 'id': '207SM0001X', 'name': 'Medical Genetics, Molecular Genetic Pathology' }, {
  'id': '207U00000X',
  'name': 'Nuclear Medicine'
}, { 'id': '207UN0903X', 'name': 'Nuclear Medicine, In Vivo & In Vitro Nuclear Medicine' }, {
  'id': '207UN0901X',
  'name': 'Nuclear Medicine, Nuclear Cardiology'
}, { 'id': '204C00000X', 'name': 'Neuromusculoskeletal Medicine, Sports Medicine' }, {
  'id': '207VB0002X',
  'name': 'Obstetrics & Gynecology, Obesity Medicine'
}, { 'id': '207VH0002X', 'name': 'Obstetrics & Gynecology, Hospice and Palliative Medicine' }, {
  'id': '204E00000X',
  'name': 'Oral & Maxillofacial Surgery'
}, { 'id': '207XS0106X', 'name': 'Orthopaedic Surgery, Hand Surgery' }, {
  'id': '207YS0123X',
  'name': 'Otolaryngology, Facial Plastic Surgery'
}, { 'id': '207YX0602X', 'name': 'Otolaryngology, Otolaryngic Allergy' }, {
  'id': '207YX0905X',
  'name': 'Otolaryngology, Otolaryngology/Facial Plastic Surgery'
}, { 'id': '207YX0007X', 'name': 'Otolaryngology, Plastic Surgery within the Head & Neck' }, {
  'id': '207YS0012X',
  'name': 'Otolaryngology, Sleep Medicine'
}, { 'id': '207ZP0105X', 'name': 'Pathology, Clinical Pathology/Laboratory Medicine' }, {
  'id': '207ZD0900X',
  'name': 'Pathology, Dermatopathology'
}, { 'id': '207ZI0100X', 'name': 'Pathology, Immunopathology' }, {
  'id': '207ZP0007X',
  'name': 'Pathology, Molecular Genetic Pathology'
}, { 'id': '2080C0008X', 'name': 'Pediatrics, Child Abuse Pediatrics' }, {
  'id': '2080P0006X',
  'name': 'Pediatrics, Developmental - Behavioral Pediatrics'
}, { 'id': '2080H0002X', 'name': 'Pediatrics, Hospice and Palliative Medicine' }, {
  'id': '2080P0008X',
  'name': 'Pediatrics, Neurodevelopmental Disabilities'
}, { 'id': '2080P0214X', 'name': 'Pediatrics, Pediatric Pulmonology' }, {
  'id': '2080T0004X',
  'name': 'Pediatrics, Pediatric Transplant Hepatology'
}, { 'id': '2080S0012X', 'name': 'Pediatrics, Sleep Medicine' }, {
  'id': '202K00000X',
  'name': 'Phlebology'
}, {
  'id': '2081H0002X',
  'name': 'Physical Medicine & Rehabilitation, Hospice and Palliative Medicine'
}, { 'id': '2081N0008X', 'name': 'Physical Medicine & Rehabilitation, Neuromuscular Medicine' }, {
  'id': '2081P2900X',
  'name': 'Physical Medicine & Rehabilitation, Pain Medicine'
}, {
  'id': '2081P0010X',
  'name': 'Physical Medicine & Rehabilitation, Pediatric Rehabilitation Medicine'
}, { 'id': '2081S0010X', 'name': 'Physical Medicine & Rehabilitation, Sports Medicine' }, {
  'id': '2082S0105X',
  'name': 'Plastic Surgery, Surgery of the Hand'
}, { 'id': '2083T0002X', 'name': 'Preventive Medicine, Medical Toxicology' }, {
  'id': '2083P0500X',
  'name': 'Preventive Medicine, Preventive Medicine/Occupational Environmental Medicine'
}, { 'id': '2083S0010X', 'name': 'Preventive Medicine, Sports Medicine' }, {
  'id': '2084P0802X',
  'name': 'Psychiatry & Neurology, Addiction Psychiatry'
}, { 'id': '2084B0002X', 'name': 'Psychiatry & Neurology, Obesity Medicine' }, {
  'id': '2084D0003X',
  'name': 'Psychiatry & Neurology, Diagnostic Neuroimaging'
}, { 'id': '2084H0002X', 'name': 'Psychiatry & Neurology, Hospice and Palliative Medicine' }, {
  'id': '2084P0005X',
  'name': 'Psychiatry & Neurology, Neurodevelopmental Disabilities'
}, { 'id': '2084N0008X', 'name': 'Psychiatry & Neurology, Neuromuscular Medicine' }, {
  'id': '2084P0015X',
  'name': 'Psychiatry & Neurology, Psychosomatic Medicine'
}, { 'id': '2084V0102X', 'name': 'Psychiatry & Neurology, Vascular Neurology' }, {
  'id': '208VP0014X',
  'name': 'Pain Medicine, Interventional Pain Medicine'
}, { 'id': '2085U0001X', 'name': 'Radiology, Diagnostic Ultrasound' }, {
  'id': '2085H0002X',
  'name': 'Radiology, Hospice and Palliative Medicine'
}, { 'id': '2085R0203X', 'name': 'Radiology, Therapeutic Radiology' }, {
  'id': '2086S0122X',
  'name': 'Surgery, Plastic and Reconstructive Surgery'
}, { 'id': '103K00000X', 'name': 'Behavior Analyst' }, {
  'id': '103G00000X',
  'name': 'Clinical Neuropsychologist'
}, { 'id': '103GC0700X', 'name': 'Clinical Neuropsychologist, Clinical' }, {
  'id': '101Y00000X',
  'name': 'Counselor'
}, { 'id': '101YA0400X', 'name': 'Counselor, Addiction (Substance Use Disorder)' }, {
  'id': '101YP1600X',
  'name': 'Counselor, Pastoral'
}, { 'id': '101YP2500X', 'name': 'Counselor, Professional' }, {
  'id': '106H00000X',
  'name': 'Marriage & Family Therapist'
}, { 'id': '102X00000X', 'name': 'Poetry Therapist' }, {
  'id': '103T00000X',
  'name': 'Psychologist'
}, { 'id': '103TA0400X', 'name': 'Psychologist, Addiction (Substance Use Disorder)' }, {
  'id': '103TC0700X',
  'name': 'Psychologist, Clinical'
}, { 'id': '103TC2200X', 'name': 'Psychologist, Clinical Child & Adolescent' }, {
  'id': '103TB0200X',
  'name': 'Psychologist, Cognitive & Behavioral'
}, { 'id': '103TE1000X', 'name': 'Psychologist, Educational' }, {
  'id': '103TE1100X',
  'name': 'Psychologist, Exercise & Sports'
}, { 'id': '103TF0200X', 'name': 'Psychologist, Forensic' }, {
  'id': '103TH0004X',
  'name': 'Psychologist, Health'
}, { 'id': '103TH0100X', 'name': 'Psychologist, Health Service' }, {
  'id': '103TM1800X',
  'name': 'Psychologist, Mental Retardation & Developmental Disabilities'
}, { 'id': '103TP0016X', 'name': 'Psychologist, Prescribing (Medical)' }, {
  'id': '103TP2700X',
  'name': 'Psychologist, Psychotherapy'
}, { 'id': '103TR0400X', 'name': 'Psychologist, Rehabilitation' }, {
  'id': '103TW0100X',
  'name': 'Psychologist, Women'
}, { 'id': '104100000X', 'name': 'Social Worker' }, {
  'id': '1041S0200X',
  'name': 'Social Worker, School'
}, { 'id': '111N00000X', 'name': 'Chiropractor' }, {
  'id': '111NI0013X',
  'name': 'Chiropractor, Independent Medical Examiner'
}, { 'id': '111NN0400X', 'name': 'Chiropractor, Neurology' }, {
  'id': '111NX0100X',
  'name': 'Chiropractor, Occupational Health'
}, { 'id': '111NX0800X', 'name': 'Chiropractor, Orthopedic' }, {
  'id': '111NR0200X',
  'name': 'Chiropractor, Radiology'
}, { 'id': '111NR0400X', 'name': 'Chiropractor, Rehabilitation' }, {
  'id': '111NT0100X',
  'name': 'Chiropractor, Thermography'
}, { 'id': '126800000X', 'name': 'Dental Assistant' }, {
  'id': '124Q00000X',
  'name': 'Dental Hygienist'
}, { 'id': '126900000X', 'name': 'Dental Laboratory Technician' }, {
  'id': '122300000X',
  'name': 'Dentist'
}, { 'id': '1223D0001X', 'name': 'Dentist, Dental Public Health' }, {
  'id': '1223E0200X',
  'name': 'Dentist, Endodontics'
}, { 'id': '1223G0001X', 'name': 'Dentist, General Practice' }, {
  'id': '1223S0112X',
  'name': 'Dentist, Oral and Maxillofacial Surgery'
}, { 'id': '1223X0400X', 'name': 'Dentist, Orthodontics and Dentofacial Orthopedics' }, {
  'id': '1223P0221X',
  'name': 'Dentist, Pediatric Dentistry'
}, { 'id': '1223P0300X', 'name': 'Dentist, Periodontics' }, {
  'id': '1223P0700X',
  'name': 'Dentist, Prosthodontics'
}, { 'id': '122400000X', 'name': 'Denturist' }, { 'id': '132700000X', 'name': 'Dietary Manager' }, {
  'id': '136A00000X',
  'name': 'Dietetic Technician, Registered'
}, { 'id': '133VN1004X', 'name': 'Dietitian, Registered, Nutrition, Pediatric' }, {
  'id': '133N00000X',
  'name': 'Nutritionist'
}, { 'id': '133NN1002X', 'name': 'Nutritionist, Nutrition, Education' }, {
  'id': '146N00000X',
  'name': 'Emergency Medical Technician, Basic'
}, { 'id': '146M00000X', 'name': 'Emergency Medical Technician, Intermediate' }, {
  'id': '146L00000X',
  'name': 'Emergency Medical Technician, Paramedic'
}, { 'id': '146D00000X', 'name': 'Personal Emergency Response Attendant' }, {
  'id': '152W00000X',
  'name': 'Optometrist'
}, { 'id': '152WC0802X', 'name': 'Optometrist, Corneal and Contact Management' }, {
  'id': '152WX0102X',
  'name': 'Optometrist, Occupational Vision'
}, { 'id': '152WP0200X', 'name': 'Optometrist, Pediatrics' }, {
  'id': '152WS0006X',
  'name': 'Optometrist, Sports Vision'
}, { 'id': '156F00000X', 'name': 'Technician/Technologist' }, {
  'id': '156FC0800X',
  'name': 'Technician/Technologist, Contact Lens'
}, { 'id': '156FX1700X', 'name': 'Technician/Technologist, Ocularist' }, {
  'id': '156FX1101X',
  'name': 'Technician/Technologist, Ophthalmic Assistant'
}, { 'id': '156FX1201X', 'name': 'Technician/Technologist, Optometric Assistant' }, {
  'id': '156FX1900X',
  'name': 'Technician/Technologist, Orthoptist'
}, { 'id': '164W00000X', 'name': 'Licensed Practical Nurse' }, {
  'id': '167G00000X',
  'name': 'Licensed Psychiatric Technician'
}, { 'id': '164X00000X', 'name': 'Licensed Vocational Nurse' }, {
  'id': '163W00000X',
  'name': 'Registered Nurse'
}, { 'id': '163WA0400X', 'name': 'Registered Nurse, Addiction (Substance Use Disorder)' }, {
  'id': '163WP2201X',
  'name': 'Registered Nurse, Ambulatory Care'
}, { 'id': '163WC0400X', 'name': 'Registered Nurse, Case Management' }, {
  'id': '163WC1400X',
  'name': 'Registered Nurse, College Health'
}, { 'id': '163WC2100X', 'name': 'Registered Nurse, Continence Care' }, {
  'id': '163WC1600X',
  'name': 'Registered Nurse, Continuing Education/Staff Development'
}, { 'id': '163WD0400X', 'name': 'Registered Nurse, Diabetes Educator' }, {
  'id': '163WE0003X',
  'name': 'Registered Nurse, Emergency'
}, { 'id': '163WE0900X', 'name': 'Registered Nurse, Enterostomal Therapy' }, {
  'id': '163WG0100X',
  'name': 'Registered Nurse, Gastroenterology'
}, { 'id': '163WG0600X', 'name': 'Registered Nurse, Gerontology' }, {
  'id': '163WH0500X',
  'name': 'Registered Nurse, Hemodialysis'
}, { 'id': '163WH1000X', 'name': 'Registered Nurse, Hospice' }, {
  'id': '163WI0500X',
  'name': 'Registered Nurse, Infusion Therapy'
}, { 'id': '163WL0100X', 'name': 'Registered Nurse, Lactation Consultant' }, {
  'id': '163WM0705X',
  'name': 'Registered Nurse, Medical-Surgical'
}, { 'id': '163WN0003X', 'name': 'Registered Nurse, Neonatal, Low-Risk' }, {
  'id': '163WN0300X',
  'name': 'Registered Nurse, Nephrology'
}, { 'id': '163WM1400X', 'name': 'Registered Nurse, Nurse Massage Therapist (NMT)' }, {
  'id': '163WN1003X',
  'name': 'Registered Nurse, Nutrition Support'
}, { 'id': '163WX0003X', 'name': 'Registered Nurse, Obstetric, Inpatient' }, {
  'id': '163WX0106X',
  'name': 'Registered Nurse, Occupational Health'
}, { 'id': '163WX1100X', 'name': 'Registered Nurse, Ophthalmic' }, {
  'id': '163WX1500X',
  'name': 'Registered Nurse, Ostomy Care'
}, { 'id': '163WP0000X', 'name': 'Registered Nurse, Pain Management' }, {
  'id': '163WP0218X',
  'name': 'Registered Nurse, Pediatric Oncology'
}, { 'id': '163WP1700X', 'name': 'Registered Nurse, Perinatal' }, {
  'id': '163WS0121X',
  'name': 'Registered Nurse, Plastic Surgery'
}, { 'id': '163WP0808X', 'name': 'Registered Nurse, Psychiatric/Mental Health' }, {
  'id': '163WP0809X',
  'name': 'Registered Nurse, Psychiatric/Mental Health, Adult'
}, {
  'id': '163WP0807X',
  'name': 'Registered Nurse, Psychiatric/Mental Health, Child & Adolescent'
}, { 'id': '163WR0006X', 'name': 'Registered Nurse, Registered Nurse First Assistant' }, {
  'id': '163WR0400X',
  'name': 'Registered Nurse, Rehabilitation'
}, { 'id': '163WR1000X', 'name': 'Registered Nurse, Reproductive Endocrinology/Infertility' }, {
  'id': '163WS0200X',
  'name': 'Registered Nurse, School'
}, { 'id': '163WU0100X', 'name': 'Registered Nurse, Urology' }, {
  'id': '163WW0101X',
  'name': "Registered Nurse, Women's Health Care, Ambulatory"
}, { 'id': '163WW0000X', 'name': 'Registered Nurse, Wound Care' }, {
  'id': '372600000X',
  'name': 'Adult Companion'
}, { 'id': '372500000X', 'name': 'Chore Provider' }, {
  'id': '373H00000X',
  'name': 'Day Training/Habilitation Specialist'
}, { 'id': '374J00000X', 'name': 'Doula' }, { 'id': '374U00000X', 'name': 'Home Health Aide' }, {
  'id': '376J00000X',
  'name': 'Homemaker'
}, { 'id': '376K00000X', 'name': "Nurse's Aide" }, {
  'id': '376G00000X',
  'name': 'Nursing Home Administrator'
}, { 'id': '374T00000X', 'name': 'Religious Nonmedical Nursing Personnel' }, {
  'id': '374K00000X',
  'name': 'Religious Nonmedical Practitioner'
}, { 'id': '374700000X', 'name': 'Technician' }, {
  'id': '3747A0650X',
  'name': 'Technician, Attendant Care Provider'
}, { 'id': '3747P1801X', 'name': 'Technician, Personal Care Attendant' }, {
  'id': '171100000X',
  'name': 'Acupuncturist'
}, { 'id': '171M00000X', 'name': 'Case Manager/Care Coordinator' }, {
  'id': '174V00000X',
  'name': 'Clinical Ethicist'
}, { 'id': '172V00000X', 'name': 'Community Health Worker' }, {
  'id': '171W00000X',
  'name': 'Contractor'
}, { 'id': '171WH0202X', 'name': 'Contractor, Home Modifications' }, {
  'id': '171WV0202X',
  'name': 'Contractor, Vehicle Modifications'
}, { 'id': '172A00000X', 'name': 'Driver' }, { 'id': '176P00000X', 'name': 'Funeral Director' }, {
  'id': '170300000X',
  'name': 'Genetic Counselor, MS'
}, { 'id': '174H00000X', 'name': 'Health Educator' }, { 'id': '175L00000X', 'name': 'Homeopath' }, {
  'id': '171R00000X',
  'name': 'Interpreter'
}, { 'id': '174N00000X', 'name': 'Lactation Consultant, Non-RN' }, {
  'id': '172M00000X',
  'name': 'Mechanotherapist'
}, { 'id': '170100000X', 'name': 'Medical Genetics, Ph.D. Medical Genetics' }, {
  'id': '176B00000X',
  'name': 'Midwife'
}, { 'id': '175M00000X', 'name': 'Midwife, Lay' }, { 'id': '172P00000X', 'name': 'Naprapath' }, {
  'id': '175F00000X',
  'name': 'Naturopath'
}, { 'id': '173C00000X', 'name': 'Reflexologist' }, {
  'id': '173F00000X',
  'name': 'Sleep Specialist, PhD'
}, { 'id': '174400000X', 'name': 'Specialist' }, {
  'id': '1744G0900X',
  'name': 'Specialist, Graphics Designer'
}, { 'id': '1744P3200X', 'name': 'Specialist, Prosthetics Case Management' }, {
  'id': '1744R1103X',
  'name': 'Specialist, Research Data Abstracter/Coder'
}, { 'id': '1744R1102X', 'name': 'Specialist, Research Study' }, {
  'id': '174M00000X',
  'name': 'Veterinarian'
}, { 'id': '174MM1900X', 'name': 'Veterinarian, Medical Research' }, {
  'id': '183500000X',
  'name': 'Pharmacist'
}, { 'id': '1835G0000X', 'name': 'Pharmacist, General Practice' }, {
  'id': '1835G0303X',
  'name': 'Pharmacist, Geriatric'
}, { 'id': '1835N0905X', 'name': 'Pharmacist, Nuclear' }, {
  'id': '1835N1003X',
  'name': 'Pharmacist, Nutrition Support'
}, { 'id': '1835X0200X', 'name': 'Pharmacist, Oncology' }, {
  'id': '1835P0018X',
  'name': 'Pharmacist, Pharmacist Clinician (PhC)/ Clinical Pharmacy Specialist'
}, { 'id': '1835P1200X', 'name': 'Pharmacist, Pharmacotherapy' }, {
  'id': '1835P1300X',
  'name': 'Pharmacist, Psychiatric'
}, { 'id': '183700000X', 'name': 'Pharmacy Technician' }, {
  'id': '367A00000X',
  'name': 'Advanced Practice Midwife'
}, { 'id': '367H00000X', 'name': 'Anesthesiologist Assistant' }, {
  'id': '364S00000X',
  'name': 'Clinical Nurse Specialist'
}, { 'id': '364SA2100X', 'name': 'Clinical Nurse Specialist, Acute Care' }, {
  'id': '364SA2200X',
  'name': 'Clinical Nurse Specialist, Adult Health'
}, { 'id': '364SC2300X', 'name': 'Clinical Nurse Specialist, Chronic Care' }, {
  'id': '364SC1501X',
  'name': 'Clinical Nurse Specialist, Community Health/Public Health'
}, { 'id': '364SC0200X', 'name': 'Clinical Nurse Specialist, Critical Care Medicine' }, {
  'id': '364SE0003X',
  'name': 'Clinical Nurse Specialist, Emergency'
}, { 'id': '364SE1400X', 'name': 'Clinical Nurse Specialist, Ethics' }, {
  'id': '364SF0001X',
  'name': 'Clinical Nurse Specialist, Family Health'
}, { 'id': '364SG0600X', 'name': 'Clinical Nurse Specialist, Gerontology' }, {
  'id': '364SH1100X',
  'name': 'Clinical Nurse Specialist, Holistic'
}, { 'id': '364SH0200X', 'name': 'Clinical Nurse Specialist, Home Health' }, {
  'id': '364SI0800X',
  'name': 'Clinical Nurse Specialist, Informatics'
}, { 'id': '364SL0600X', 'name': 'Clinical Nurse Specialist, Long-Term Care' }, {
  'id': '364SM0705X',
  'name': 'Clinical Nurse Specialist, Medical-Surgical'
}, { 'id': '364SN0000X', 'name': 'Clinical Nurse Specialist, Neonatal' }, {
  'id': '364SN0800X',
  'name': 'Clinical Nurse Specialist, Neuroscience'
}, { 'id': '364SX0200X', 'name': 'Clinical Nurse Specialist, Oncology' }, {
  'id': '364SX0204X',
  'name': 'Clinical Nurse Specialist, Oncology, Pediatrics'
}, { 'id': '364SP2800X', 'name': 'Clinical Nurse Specialist, Perioperative' }, {
  'id': '364SP0809X',
  'name': 'Clinical Nurse Specialist, Psychiatric/Mental Health, Adult'
}, {
  'id': '364SP0807X',
  'name': 'Clinical Nurse Specialist, Psychiatric/Mental Health, Child & Adolescent'
}, {
  'id': '364SP0811X',
  'name': 'Clinical Nurse Specialist, Psychiatric/Mental Health, Chronically Ill'
}, {
  'id': '364SP0812X',
  'name': 'Clinical Nurse Specialist, Psychiatric/Mental Health, Community'
}, { 'id': '364SR0400X', 'name': 'Clinical Nurse Specialist, Rehabilitation' }, {
  'id': '364SS0200X',
  'name': 'Clinical Nurse Specialist, School'
}, { 'id': '364SW0102X', 'name': "Clinical Nurse Specialist, Women's Health" }, {
  'id': '367500000X',
  'name': 'Nurse Anesthetist, Certified Registered'
}, { 'id': '363L00000X', 'name': 'Nurse Practitioner' }, {
  'id': '363LA2200X',
  'name': 'Nurse Practitioner, Adult Health'
}, { 'id': '363LC0200X', 'name': 'Nurse Practitioner, Critical Care Medicine' }, {
  'id': '363LG0600X',
  'name': 'Nurse Practitioner, Gerontology'
}, { 'id': '363LN0005X', 'name': 'Nurse Practitioner, Neonatal, Critical Care' }, {
  'id': '363LX0106X',
  'name': 'Nurse Practitioner, Occupational Health'
}, { 'id': '363LP0200X', 'name': 'Nurse Practitioner, Pediatrics' }, {
  'id': '363LP1700X',
  'name': 'Nurse Practitioner, Perinatal'
}, { 'id': '363LP2300X', 'name': 'Nurse Practitioner, Primary Care' }, {
  'id': '363LS0200X',
  'name': 'Nurse Practitioner, School'
}, { 'id': '363LW0102X', 'name': "Nurse Practitioner, Women's Health" }, {
  'id': '363A00000X',
  'name': 'Physician Assistant'
}, { 'id': '363AS0400X', 'name': 'Physician Assistant, Surgical' }, {
  'id': '211D00000X',
  'name': 'Assistant, Podiatric'
}, { 'id': '213E00000X', 'name': 'Podiatrist' }, {
  'id': '213ES0131X',
  'name': 'Podiatrist, Foot Surgery'
}, { 'id': '213EG0000X', 'name': 'Podiatrist, General Practice' }, {
  'id': '213EP0504X',
  'name': 'Podiatrist, Public Medicine'
}, { 'id': '213ER0200X', 'name': 'Podiatrist, Radiology' }, {
  'id': '213ES0000X',
  'name': 'Podiatrist, Sports Medicine'
}, { 'id': '229N00000X', 'name': 'Anaplastologist' }, {
  'id': '221700000X',
  'name': 'Art Therapist'
}, { 'id': '225600000X', 'name': 'Dance Therapist' }, {
  'id': '222Q00000X',
  'name': 'Developmental Therapist'
}, { 'id': '226300000X', 'name': 'Kinesiotherapist' }, {
  'id': '225700000X',
  'name': 'Massage Therapist'
}, { 'id': '224900000X', 'name': 'Mastectomy Fitter' }, {
  'id': '225A00000X',
  'name': 'Music Therapist'
}, { 'id': '225X00000X', 'name': 'Occupational Therapist' }, {
  'id': '225XE0001X',
  'name': 'Occupational Therapist, Environmental Modification'
}, { 'id': '225XE1200X', 'name': 'Occupational Therapist, Ergonomics' }, {
  'id': '225XG0600X',
  'name': 'Occupational Therapist, Gerontology'
}, { 'id': '225XH1300X', 'name': 'Occupational Therapist, Human Factors' }, {
  'id': '225XM0800X',
  'name': 'Occupational Therapist, Mental Health'
}, { 'id': '225XP0200X', 'name': 'Occupational Therapist, Pediatrics' }, {
  'id': '224Z00000X',
  'name': 'Occupational Therapy Assistant'
}, {
  'id': '224ZR0403X',
  'name': 'Occupational Therapy Assistant, Driving and Community Mobility'
}, { 'id': '224ZF0002X', 'name': 'Occupational Therapy Assistant, Feeding, Eating & Swallowing' }, {
  'id': '224ZL0004X',
  'name': 'Occupational Therapy Assistant, Low Vision'
}, { 'id': '225000000X', 'name': 'Orthotic Fitter' }, { 'id': '222Z00000X', 'name': 'Orthotist' }, {
  'id': '224L00000X',
  'name': 'Pedorthist'
}, { 'id': '225100000X', 'name': 'Physical Therapist' }, {
  'id': '2251E1300X',
  'name': 'Physical Therapist, Electrophysiology, Clinical'
}, { 'id': '2251G0304X', 'name': 'Physical Therapist, Geriatrics' }, {
  'id': '2251H1300X',
  'name': 'Physical Therapist, Human Factors'
}, { 'id': '2251X0800X', 'name': 'Physical Therapist, Orthopedic' }, {
  'id': '2251S0007X',
  'name': 'Physical Therapist, Sports'
}, { 'id': '225200000X', 'name': 'Physical Therapy Assistant' }, {
  'id': '224P00000X',
  'name': 'Prosthetist'
}, { 'id': '225B00000X', 'name': 'Pulmonary Function Technologist' }, {
  'id': '225800000X',
  'name': 'Recreation Therapist'
}, { 'id': '225C00000X', 'name': 'Rehabilitation Counselor' }, {
  'id': '225CA2500X',
  'name': 'Rehabilitation Counselor, Assistive Technology Supplier'
}, {
  'id': '225CX0006X',
  'name': 'Rehabilitation Counselor, Orientation and Mobility Training Provider'
}, { 'id': '225400000X', 'name': 'Rehabilitation Practitioner' }, {
  'id': '227800000X',
  'name': 'Respiratory Therapist, Certified'
}, { 'id': '2278E0002X', 'name': 'Respiratory Therapist, Certified, Emergency Care' }, {
  'id': '2278G0305X',
  'name': 'Respiratory Therapist, Certified, Geriatric Care'
}, { 'id': '2278P3800X', 'name': 'Respiratory Therapist, Certified, Palliative/Hospice' }, {
  'id': '2278P1004X',
  'name': 'Respiratory Therapist, Certified, Pulmonary Diagnostics'
}, { 'id': '2278P1005X', 'name': 'Respiratory Therapist, Certified, Pulmonary Rehabilitation' }, {
  'id': '2278S1500X',
  'name': 'Respiratory Therapist, Certified, SNF/Subacute Care'
}, { 'id': '227900000X', 'name': 'Respiratory Therapist, Registered' }, {
  'id': '2279E0002X',
  'name': 'Respiratory Therapist, Registered, Emergency Care'
}, { 'id': '2279G0305X', 'name': 'Respiratory Therapist, Registered, Geriatric Care' }, {
  'id': '2279P3800X',
  'name': 'Respiratory Therapist, Registered, Palliative/Hospice'
}, { 'id': '2279P1004X', 'name': 'Respiratory Therapist, Registered, Pulmonary Diagnostics' }, {
  'id': '2279P1006X',
  'name': 'Respiratory Therapist, Registered, Pulmonary Function Technologist'
}, { 'id': '2279P1005X', 'name': 'Respiratory Therapist, Registered, Pulmonary Rehabilitation' }, {
  'id': '2279S1500X',
  'name': 'Respiratory Therapist, Registered, SNF/Subacute Care'
}, { 'id': '225500000X', 'name': 'Specialist/Technologist' }, {
  'id': '2255A2300X',
  'name': 'Specialist/Technologist, Athletic Trainer'
}, { 'id': '2255R0406X', 'name': 'Specialist/Technologist, Rehabilitation, Blind' }, {
  'id': '231H00000X',
  'name': 'Audiologist'
}, { 'id': '231HA2400X', 'name': 'Audiologist, Assistive Technology Practitioner' }, {
  'id': '231HA2500X',
  'name': 'Audiologist, Assistive Technology Supplier'
}, { 'id': '237600000X', 'name': 'Audiologist-Hearing Aid Fitter' }, {
  'id': '237700000X',
  'name': 'Hearing Instrument Specialist'
}, { 'id': '235500000X', 'name': 'Specialist/Technologist' }, {
  'id': '2355A2700X',
  'name': 'Specialist/Technologist, Audiology Assistant'
}, { 'id': '2355S0801X', 'name': 'Specialist/Technologist, Speech-Language Assistant' }, {
  'id': '235Z00000X',
  'name': 'Speech-Language Pathologist'
}, {
  'id': '390200000X',
  'name': 'Student in an Organized Health Care Education/Training Program'
}, { 'id': '242T00000X', 'name': 'Perfusionist' }, {
  'id': '247100000X',
  'name': 'Radiologic Technologist'
}, { 'id': '2471B0102X', 'name': 'Radiologic Technologist, Bone Densitometry' }, {
  'id': '2471C1106X',
  'name': 'Radiologic Technologist, Cardiac-Interventional Technology'
}, {
  'id': '2471C1101X',
  'name': 'Radiologic Technologist, Cardiovascular-Interventional Technology'
}, { 'id': '2471C3401X', 'name': 'Radiologic Technologist, Computed Tomography' }, {
  'id': '2471M1202X',
  'name': 'Radiologic Technologist, Magnetic Resonance Imaging'
}, { 'id': '2471M2300X', 'name': 'Radiologic Technologist, Mammography' }, {
  'id': '2471N0900X',
  'name': 'Radiologic Technologist, Nuclear Medicine Technology'
}, { 'id': '2471Q0001X', 'name': 'Radiologic Technologist, Quality Management' }, {
  'id': '2471R0002X',
  'name': 'Radiologic Technologist, Radiation Therapy'
}, { 'id': '2471C3402X', 'name': 'Radiologic Technologist, Radiography' }, {
  'id': '2471S1302X',
  'name': 'Radiologic Technologist, Sonography'
}, { 'id': '2471V0105X', 'name': 'Radiologic Technologist, Vascular Sonography' }, {
  'id': '2471V0106X',
  'name': 'Radiologic Technologist, Vascular-Interventional Technology'
}, { 'id': '243U00000X', 'name': 'Radiology Practitioner Assistant' }, {
  'id': '246X00000X',
  'name': 'Specialist/Technologist Cardiovascular'
}, {
  'id': '246XC2901X',
  'name': 'Specialist/Technologist Cardiovascular, Cardiovascular Invasive Specialist'
}, { 'id': '246XS1301X', 'name': 'Specialist/Technologist Cardiovascular, Sonography' }, {
  'id': '246XC2903X',
  'name': 'Specialist/Technologist Cardiovascular, Vascular Specialist'
}, { 'id': '246Y00000X', 'name': 'Specialist/Technologist, Health Information' }, {
  'id': '246YC3301X',
  'name': 'Specialist/Technologist, Health Information, Coding Specialist, Hospital Based'
}, {
  'id': '246YC3302X',
  'name': 'Specialist/Technologist, Health Information, Coding Specialist, Physician Office Based'
}, {
  'id': '246YR1600X',
  'name': 'Specialist/Technologist, Health Information, Registered Record Administrator'
}, { 'id': '246ZB0500X', 'name': 'Specialist/Technologist, Other, Biochemist' }, {
  'id': '246ZB0302X',
  'name': 'Specialist/Technologist, Other, Biomedical Photographer'
}, { 'id': '246ZC0007X', 'name': 'Specialist/Technologist, Other, Surgical Assistant' }, {
  'id': '246ZE0600X',
  'name': 'Specialist/Technologist, Other, Electroneurodiagnostic'
}, { 'id': '246ZG0701X', 'name': 'Specialist/Technologist, Other, Graphics Methods' }, {
  'id': '246ZN0300X',
  'name': 'Specialist/Technologist, Other, Nephrology'
}, { 'id': '246ZS0400X', 'name': 'Surgical' }, {
  'id': '246Q00000X',
  'name': 'Specialist/Technologist, Pathology'
}, { 'id': '246QC1000X', 'name': 'Specialist/Technologist, Pathology, Chemistry' }, {
  'id': '246QH0000X',
  'name': 'Specialist/Technologist, Pathology, Hematology'
}, { 'id': '246QI0000X', 'name': 'Specialist/Technologist, Pathology, Immunology' }, {
  'id': '246QL0901X',
  'name': 'Specialist/Technologist, Pathology, Laboratory Management, Diplomate'
}, { 'id': '246QM0900X', 'name': 'Specialist/Technologist, Pathology, Microbiology' }, {
  'id': '246W00000X',
  'name': 'Technician, Cardiology'
}, { 'id': '247000000X', 'name': 'Technician, Health Information' }, {
  'id': '247200000X',
  'name': 'Technician, Other'
}, { 'id': '2472B0301X', 'name': 'Technician, Other, Biomedical Engineering' }, {
  'id': '2472D0500X',
  'name': 'Technician, Other, Darkroom'
}, { 'id': '2472R0900X', 'name': 'Technician, Other, Renal Dialysis' }, {
  'id': '247ZC0005X',
  'name': 'Pathology, Clinical Laboratory Director, Non-physician'
}, { 'id': '246RM2200X', 'name': 'Technician, Pathology, Medical Laboratory' }, {
  'id': '251300000X',
  'name': 'Local Education Agency (LEA)'
}, { 'id': '251B00000X', 'name': 'Case Management' }, {
  'id': '251S00000X',
  'name': 'Community/Behavioral Health'
}, { 'id': '251C00000X', 'name': 'Day Training, Developmentally Disabled Services' }, {
  'id': '252Y00000X',
  'name': 'Early Intervention Provider Agency'
}, { 'id': '253J00000X', 'name': 'Foster Care Agency' }, {
  'id': '251E00000X',
  'name': 'Home Health'
}, { 'id': '251F00000X', 'name': 'Home Infusion' }, {
  'id': '251G00000X',
  'name': 'Hospice Care, Community Based'
}, { 'id': '253Z00000X', 'name': 'In Home Supportive Care' }, {
  'id': '251J00000X',
  'name': 'Nursing Care'
}, {
  'id': '251T00000X',
  'name': 'Program of All-Inclusive Care for the Elderly (PACE) Provider Organization'
}, { 'id': '251K00000X', 'name': 'Public Health or Welfare' }, {
  'id': '251X00000X',
  'name': 'Supports Brokerage'
}, { 'id': '251V00000X', 'name': 'Voluntary or Charitable' }, {
  'id': '261Q00000X',
  'name': 'Clinic/Center'
}, { 'id': '261QM0855X', 'name': 'Clinic/Center, Adolescent and Children Mental Health' }, {
  'id': '261QA0600X',
  'name': 'Clinic/Center, Adult Day Care'
}, { 'id': '261QA0005X', 'name': 'Clinic/Center, Ambulatory Family Planning Facility' }, {
  'id': '261QA0006X',
  'name': 'Clinic/Center, Ambulatory Fertility Facility'
}, { 'id': '261QA0900X', 'name': 'Clinic/Center, Amputee' }, {
  'id': '261QA3000X',
  'name': 'Clinic/Center, Augmentative Communication'
}, { 'id': '261QC1500X', 'name': 'Clinic/Center, Community Health' }, {
  'id': '261QC1800X',
  'name': 'Clinic/Center, Corporate Health'
}, { 'id': '261QD0000X', 'name': 'Clinic/Center, Dental' }, {
  'id': '261QD1600X',
  'name': 'Clinic/Center, Developmental Disabilities'
}, { 'id': '261QE0800X', 'name': 'Clinic/Center, Endoscopy' }, {
  'id': '261QE0700X',
  'name': 'Clinic/Center, End-Stage Renal Disease (ESRD) Treatment'
}, { 'id': '261QF0400X', 'name': 'Clinic/Center, Federally Qualified Health Center (FQHC)' }, {
  'id': '261QG0250X',
  'name': 'Clinic/Center, Genetics'
}, { 'id': '261QH0100X', 'name': 'Clinic/Center, Health Service' }, {
  'id': '261QI0500X',
  'name': 'Clinic/Center, Infusion Therapy'
}, { 'id': '261QL0400X', 'name': 'Clinic/Center, Lithotripsy' }, {
  'id': '261QM2500X',
  'name': 'Clinic/Center, Medical Specialty'
}, {
  'id': '261QM3000X',
  'name': 'Clinic/Center, Medically Fragile Infants and Children Day Care'
}, {
  'id': '261QM0801X',
  'name': 'Clinic/Center, Mental Health (Including Community Mental Health Center)'
}, { 'id': '261QM1000X', 'name': 'Clinic/Center, Migrant Health' }, {
  'id': '261QM1101X',
  'name': 'Clinic/Center, Military and U.S. Coast Guard Ambulatory Procedure'
}, {
  'id': '261QM1102X',
  'name': 'Clinic/Center, Military Outpatient Operational (Transportable) Component'
}, { 'id': '261QM1100X', 'name': 'Clinic/Center, Military/U.S. Coast Guard Outpatient' }, {
  'id': '261QM1300X',
  'name': 'Clinic/Center, Multi-Specialty'
}, { 'id': '261QX0100X', 'name': 'Clinic/Center, Occupational Medicine' }, {
  'id': '261QX0203X',
  'name': 'Clinic/Center, Oncology, Radiation'
}, { 'id': '261QS0132X', 'name': 'Clinic/Center, Ophthalmologic Surgery' }, {
  'id': '261QP3300X',
  'name': 'Clinic/Center, Pain'
}, { 'id': '261QP2000X', 'name': 'Clinic/Center, Physical Therapy' }, {
  'id': '261QP1100X',
  'name': 'Clinic/Center, Podiatric'
}, { 'id': '261QP2400X', 'name': 'Clinic/Center, Prison Health' }, {
  'id': '261QP0905X',
  'name': 'Clinic/Center, Public Health, State or Local'
}, { 'id': '261QR0200X', 'name': 'Clinic/Center, Radiology' }, {
  'id': '261QR0208X',
  'name': 'Clinic/Center, Radiology, Mobile'
}, { 'id': '261QR0207X', 'name': 'Clinic/Center, Radiology, Mobile Mammography' }, {
  'id': '261QR0800X',
  'name': 'Clinic/Center, Recovery Care'
}, { 'id': '261QR0404X', 'name': 'Clinic/Center, Rehabilitation, Cardiac Facilities' }, {
  'id': '261QR0401X',
  'name': 'Clinic/Center, Rehabilitation, Comprehensive Outpatient Rehabilitation Facility (CORF)'
}, { 'id': '261QR1100X', 'name': 'Clinic/Center, Research' }, {
  'id': '261QR1300X',
  'name': 'Clinic/Center, Rural Health'
}, { 'id': '261QS1200X', 'name': 'Clinic/Center, Sleep Disorder Diagnostic' }, {
  'id': '261QU0200X',
  'name': 'Clinic/Center, Urgent Care'
}, { 'id': '261QV0200X', 'name': 'Clinic/Center, VA' }, {
  'id': '273100000X',
  'name': 'Epilepsy Unit'
}, { 'id': '275N00000X', 'name': 'Medicare Defined Swing Bed Unit' }, {
  'id': '273R00000X',
  'name': 'Psychiatric Unit'
}, { 'id': '273Y00000X', 'name': 'Rehabilitation Unit' }, {
  'id': '276400000X',
  'name': 'Rehabilitation, Substance Use Disorder Unit'
}, { 'id': '287300000X', 'name': 'Christian Science Sanitorium' }, {
  'id': '281P00000X',
  'name': 'Chronic Disease Hospital'
}, { 'id': '282N00000X', 'name': 'General Acute Care Hospital' }, {
  'id': '282NC0060X',
  'name': 'General Acute Care Hospital, Critical Access'
}, { 'id': '282NW0100X', 'name': 'General Acute Care Hospital, Women' }, {
  'id': '282E00000X',
  'name': 'Long Term Care Hospital'
}, { 'id': '286500000X', 'name': 'Military Hospital' }, {
  'id': '2865M2000X',
  'name': 'Military Hospital, Military General Acute Care Hospital'
}, { 'id': '283Q00000X', 'name': 'Psychiatric Hospital' }, {
  'id': '283X00000X',
  'name': 'Rehabilitation Hospital'
}, { 'id': '283XC2000X', 'name': 'Rehabilitation Hospital, Children' }, {
  'id': '282J00000X',
  'name': 'Religious Nonmedical Health Care Institution'
}, { 'id': '284300000X', 'name': 'Special Hospital' }, {
  'id': '291U00000X',
  'name': 'Clinical Medical Laboratory'
}, { 'id': '292200000X', 'name': 'Dental Laboratory' }, {
  'id': '291900000X',
  'name': 'Military Clinical Medical Laboratory'
}, { 'id': '293D00000X', 'name': 'Physiological Laboratory' }, {
  'id': '302F00000X',
  'name': 'Exclusive Provider Organization'
}, { 'id': '302R00000X', 'name': 'Health Maintenance Organization' }, {
  'id': '305S00000X',
  'name': 'Point of Service'
}, { 'id': '305R00000X', 'name': 'Preferred Provider Organization' }, {
  'id': '311500000X',
  'name': 'Alzheimer Center (Dementia Center)'
}, { 'id': '310400000X', 'name': 'Assisted Living Facility' }, {
  'id': '3104A0630X',
  'name': 'Assisted Living Facility, Assisted Living, Behavioral Disturbances'
}, { 'id': '3104A0625X', 'name': 'Assisted Living Facility, Assisted Living, Mental Illness' }, {
  'id': '317400000X',
  'name': 'Christian Science Facility'
}, { 'id': '311Z00000X', 'name': 'Custodial Care Facility' }, {
  'id': '311ZA0620X',
  'name': 'Custodial Care Facility, Adult Care Home'
}, { 'id': '315D00000X', 'name': 'Hospice, Inpatient' }, {
  'id': '310500000X',
  'name': 'Intermediate Care Facility, Mental Illness'
}, { 'id': '315P00000X', 'name': 'Intermediate Care Facility, Mentally Retarded' }, {
  'id': '313M00000X',
  'name': 'Nursing Facility/Intermediate Care Facility'
}, { 'id': '314000000X', 'name': 'Skilled Nursing Facility' }, {
  'id': '3140N1450X',
  'name': 'Skilled Nursing Facility, Nursing Care, Pediatric'
}, { 'id': '177F00000X', 'name': 'Lodging' }, { 'id': '174200000X', 'name': 'Meals' }, {
  'id': '320800000X',
  'name': 'Community Based Residential Treatment Facility, Mental Illness'
}, {
  'id': '320900000X',
  'name': 'Community Based Residential Treatment Facility, Mental Retardation and/or Developmental Disabilities'
}, { 'id': '323P00000X', 'name': 'Psychiatric Residential Treatment Facility' }, {
  'id': '322D00000X',
  'name': 'Residential Treatment Facility, Emotionally Disturbed Children'
}, { 'id': '207VX0201X', 'name': 'Obstetrics & Gynecology, Gynecologic Oncology' }, {
  'id': '207XS0117X',
  'name': 'Orthopaedic Surgery, Orthopaedic Surgery of the Spine'
}, { 'id': '207XX0801X', 'name': 'Orthopaedic Surgery, Orthopaedic Trauma' }, {
  'id': '207ZC0006X',
  'name': 'Pathology, Clinical Pathology'
}, { 'id': '207ZM0300X', 'name': 'Pathology, Medical Microbiology' }, {
  'id': '207ZP0102X',
  'name': 'Pathology, Anatomic Pathology & Clinical Pathology'
}, { 'id': '2080P0201X', 'name': 'Pediatrics, Pediatric Allergy/Immunology' }, {
  'id': '2080P0205X',
  'name': 'Pediatrics, Pediatric Endocrinology'
}, { 'id': '2080P0210X', 'name': 'Pediatrics, Pediatric Nephrology' }, {
  'id': '2081P0004X',
  'name': 'Physical Medicine & Rehabilitation, Spinal Cord Injury Medicine'
}, { 'id': '2083P0011X', 'name': 'Preventive Medicine, Undersea and Hyperbaric Medicine' }, {
  'id': '2084A0401X',
  'name': 'Psychiatry & Neurology, Addiction Medicine'
}, { 'id': '2084N0400X', 'name': 'Psychiatry & Neurology, Neurology' }, {
  'id': '2084N0600X',
  'name': 'Psychiatry & Neurology, Clinical Neurophysiology'
}, { 'id': '2084P0804X', 'name': 'Psychiatry & Neurology, Child & Adolescent Psychiatry' }, {
  'id': '2085N0700X',
  'name': 'Radiology, Neuroradiology'
}, { 'id': '2085R0001X', 'name': 'Radiology, Radiation Oncology' }, {
  'id': '2086S0102X',
  'name': 'Surgery, Surgical Critical Care'
}, { 'id': '2086X0206X', 'name': 'Surgery, Surgical Oncology' }, {
  'id': '207RH0000X',
  'name': 'Internal Medicine, Hematology'
}, { 'id': '2084P2900X', 'name': 'Psychiatry & Neurology, Pain Medicine' }, {
  'id': '2084S0010X',
  'name': 'Psychiatry & Neurology, Sports Medicine'
}, { 'id': '2085D0003X', 'name': 'Radiology, Diagnostic Neuroimaging' }, {
  'id': '2086H0002X',
  'name': 'Surgery, Hospice and Palliative Medicine'
}, { 'id': '101YM0800X', 'name': 'Counselor, Mental Health' }, {
  'id': '101YS0200X',
  'name': 'Counselor, School'
}, { 'id': '103TA0700X', 'name': 'Psychologist, Adult Development & Aging' }, {
  'id': '103TC1900X',
  'name': 'Psychologist, Counseling'
}, { 'id': '103TF0000X', 'name': 'Psychologist, Family' }, {
  'id': '103TP2701X',
  'name': 'Psychologist, Group Psychotherapy'
}, { 'id': '103TM1700X', 'name': 'Psychologist, Men & Masculinity' }, {
  'id': '103TP0814X',
  'name': 'Psychologist, Psychoanalysis'
}, { 'id': '103TS0200X', 'name': 'Psychologist, School' }, {
  'id': '1041C0700X',
  'name': 'Social Worker, Clinical'
}, { 'id': '111NI0900X', 'name': 'Chiropractor, Internist' }, {
  'id': '111NN1001X',
  'name': 'Chiropractor, Nutrition'
}, { 'id': '111NP0017X', 'name': 'Chiropractor, Pediatric Chiropractor' }, {
  'id': '111NS0005X',
  'name': 'Chiropractor, Sports Physician'
}, { 'id': '1223P0106X', 'name': 'Dentist, Oral and Maxillofacial Pathology' }, {
  'id': '133VN1006X',
  'name': 'Dietitian, Registered, Nutrition, Metabolic'
}, { 'id': '133VN1005X', 'name': 'Dietitian, Registered, Nutrition, Renal' }, {
  'id': '152WL0500X',
  'name': 'Optometrist, Low Vision Rehabilitation'
}, { 'id': '152WV0400X', 'name': 'Optometrist, Vision Therapy' }, {
  'id': '156FC0801X',
  'name': 'Technician/Technologist, Contact Lens Fitter'
}, { 'id': '156FX1100X', 'name': 'Technician/Technologist, Ophthalmic' }, {
  'id': '156FX1800X',
  'name': 'Technician/Technologist, Optician'
}, { 'id': '156FX1202X', 'name': 'Technician/Technologist, Optometric Technician' }, {
  'id': '163WA2000X',
  'name': 'Registered Nurse, Administrator'
}, { 'id': '163WC3500X', 'name': 'Registered Nurse, Cardiac Rehabilitation' }, {
  'id': '163WC1500X',
  'name': 'Registered Nurse, Community Health'
}, { 'id': '163WC0200X', 'name': 'Registered Nurse, Critical Care Medicine' }, {
  'id': '163WD1100X',
  'name': 'Registered Nurse, Dialysis, Peritoneal'
}, { 'id': '163WF0300X', 'name': 'Registered Nurse, Flight' }, {
  'id': '163WG0000X',
  'name': 'Registered Nurse, General Practice'
}, { 'id': '163WH0200X', 'name': 'Registered Nurse, Home Health' }, {
  'id': '163WI0600X',
  'name': 'Registered Nurse, Infection Control'
}, { 'id': '163WM0102X', 'name': 'Registered Nurse, Maternal Newborn' }, {
  'id': '163WN0002X',
  'name': 'Registered Nurse, Neonatal Intensive Care'
}, { 'id': '163WN0800X', 'name': 'Registered Nurse, Neuroscience' }, {
  'id': '163WX0002X',
  'name': 'Registered Nurse, Obstetric, High-Risk'
}, { 'id': '163WX0200X', 'name': 'Registered Nurse, Oncology' }, {
  'id': '163WX0800X',
  'name': 'Registered Nurse, Orthopedic'
}, { 'id': '163WX0601X', 'name': 'Registered Nurse, Otorhinolaryngology & Head-Neck' }, {
  'id': '163WP0200X',
  'name': 'Registered Nurse, Pediatrics'
}, { 'id': '364SX0106X', 'name': 'Clinical Nurse Specialist, Occupational Health' }, {
  'id': '364SP0200X',
  'name': 'Clinical Nurse Specialist, Pediatrics'
}, { 'id': '364SP1700X', 'name': 'Clinical Nurse Specialist, Perinatal' }, {
  'id': '364SP0808X',
  'name': 'Clinical Nurse Specialist, Psychiatric/Mental Health'
}, {
  'id': '364SP0810X',
  'name': 'Clinical Nurse Specialist, Psychiatric/Mental Health, Child & Family'
}, {
  'id': '364SP0813X',
  'name': 'Clinical Nurse Specialist, Psychiatric/Mental Health, Geropsychiatric'
}, { 'id': '364ST0500X', 'name': 'Clinical Nurse Specialist, Transplantation' }, {
  'id': '363LA2100X',
  'name': 'Nurse Practitioner, Acute Care'
}, { 'id': '363LC1500X', 'name': 'Nurse Practitioner, Community Health' }, {
  'id': '363LF0000X',
  'name': 'Nurse Practitioner, Family'
}, { 'id': '363LN0000X', 'name': 'Nurse Practitioner, Neonatal' }, {
  'id': '363LX0001X',
  'name': 'Nurse Practitioner, Obstetrics & Gynecology'
}, { 'id': '363LP0222X', 'name': 'Nurse Practitioner, Pediatrics, Critical Care' }, {
  'id': '363LP0808X',
  'name': 'Nurse Practitioner, Psychiatric/Mental Health'
}, { 'id': '363AM0700X', 'name': 'Physician Assistant, Medical' }, {
  'id': '213ES0103X',
  'name': 'Podiatrist, Foot & Ankle Surgery'
}, { 'id': '213EP1101X', 'name': 'Podiatrist, Primary Podiatric Medicine' }, {
  'id': '225XR0403X',
  'name': 'Occupational Therapist, Driving and Community Mobility'
}, { 'id': '225XF0002X', 'name': 'Occupational Therapist, Feeding, Eating & Swallowing' }, {
  'id': '225XH1200X',
  'name': 'Occupational Therapist, Hand'
}, { 'id': '225XL0004X', 'name': 'Occupational Therapist, Low Vision' }, {
  'id': '225XN1300X',
  'name': 'Occupational Therapist, Neurorehabilitation'
}, { 'id': '225XP0019X', 'name': 'Occupational Therapist, Physical Rehabilitation' }, {
  'id': '224ZE0001X',
  'name': 'Occupational Therapy Assistant, Environmental Modification'
}, { 'id': '2251C2600X', 'name': 'Physical Therapist, Cardiopulmonary' }, {
  'id': '2251E1200X',
  'name': 'Physical Therapist, Ergonomics'
}, { 'id': '2251H1200X', 'name': 'Physical Therapist, Hand' }, {
  'id': '2251N0400X',
  'name': 'Physical Therapist, Neurology'
}, { 'id': '2251P0200X', 'name': 'Physical Therapist, Pediatrics' }, {
  'id': '225CA2400X',
  'name': 'Rehabilitation Counselor, Assistive Technology Practitioner'
}, { 'id': '2278C0205X', 'name': 'Respiratory Therapist, Certified, Critical Care' }, {
  'id': '2278E1000X',
  'name': 'Respiratory Therapist, Certified, Educational'
}, { 'id': '2278G1100X', 'name': 'Respiratory Therapist, Certified, General Care' }, {
  'id': '2278H0200X',
  'name': 'Respiratory Therapist, Certified, Home Health'
}, { 'id': '2278P3900X', 'name': 'Respiratory Therapist, Certified, Neonatal/Pediatrics' }, {
  'id': '2278P4000X',
  'name': 'Respiratory Therapist, Certified, Patient Transport'
}, {
  'id': '2278P1006X',
  'name': 'Respiratory Therapist, Certified, Pulmonary Function Technologist'
}, { 'id': '2279C0205X', 'name': 'Respiratory Therapist, Registered, Critical Care' }, {
  'id': '2279E1000X',
  'name': 'Respiratory Therapist, Registered, Educational'
}, { 'id': '2279G1100X', 'name': 'Respiratory Therapist, Registered, General Care' }, {
  'id': '2279H0200X',
  'name': 'Respiratory Therapist, Registered, Home Health'
}, { 'id': '2279P3900X', 'name': 'Respiratory Therapist, Registered, Neonatal/Pediatrics' }, {
  'id': '2279P4000X',
  'name': 'Respiratory Therapist, Registered, Patient Transport'
}, { 'id': '246ZA2600X', 'name': 'Specialist/Technologist, Other, Art, Medical' }, {
  'id': '246ZB0301X',
  'name': 'Specialist/Technologist, Other, Biomedical Engineering'
}, { 'id': '246ZB0600X', 'name': 'Specialist/Technologist, Other, Biostatistician' }, {
  'id': '246ZE0500X',
  'name': 'Specialist/Technologist, Other, EEG'
}, { 'id': '246ZG1000X', 'name': 'Specialist/Technologist, Other, Geneticist, Medical (PhD)' }, {
  'id': '246ZI1000X',
  'name': 'Specialist/Technologist, Other, Illustration, Medical'
}, { 'id': '246QB0000X', 'name': 'Specialist/Technologist, Pathology, Blood Banking' }, {
  'id': '246QC2700X',
  'name': 'Specialist/Technologist, Pathology, Cytotechnology'
}, {
  'id': '246QH0401X',
  'name': 'Specialist/Technologist, Pathology, Hemapheresis Practitioner'
}, { 'id': '246QH0600X', 'name': 'Specialist/Technologist, Pathology, Histology' }, {
  'id': '246QL0900X',
  'name': 'Specialist/Technologist, Pathology, Laboratory Management'
}, { 'id': '246QM0706X', 'name': 'Specialist/Technologist, Pathology, Medical Technologist' }, {
  'id': '2470A2800X',
  'name': 'Technician, Health Information, Assistant Record Technician'
}, { 'id': '2472E0500X', 'name': 'Technician, Other, EEG' }, {
  'id': '2472V0600X',
  'name': 'Technician, Other, Veterinary'
}, { 'id': '246RH0600X', 'name': 'Technician, Pathology, Histology' }, {
  'id': '246RP1900X',
  'name': 'Technician, Pathology, Phlebotomy'
}, { 'id': '261QM0850X', 'name': 'Clinic/Center, Adult Mental Health' }, {
  'id': '261QA1903X',
  'name': 'Clinic/Center, Ambulatory Surgical'
}, { 'id': '261QB0400X', 'name': 'Clinic/Center, Birthing' }, {
  'id': '261QC0050X',
  'name': 'Clinic/Center, Critical Access Hospital'
}, { 'id': '261QE0002X', 'name': 'Clinic/Center, Emergency Care' }, {
  'id': '261QF0050X',
  'name': 'Clinic/Center, Family Planning, Non-Surgical'
}, { 'id': '261QH0700X', 'name': 'Clinic/Center, Hearing and Speech' }, {
  'id': '261QM1200X',
  'name': 'Clinic/Center, Magnetic Resonance Imaging (MRI)'
}, { 'id': '261QM2800X', 'name': 'Clinic/Center, Methadone' }, {
  'id': '261QM1103X',
  'name': 'Clinic/Center, Military Ambulatory Procedure Visits Operational (Transportable)'
}, { 'id': '261QX0200X', 'name': 'Clinic/Center, Oncology' }, {
  'id': '261QS0112X',
  'name': 'Clinic/Center, Oral and Maxillofacial Surgery'
}, { 'id': '261QP2300X', 'name': 'Clinic/Center, Primary Care' }, {
  'id': '261QP0904X',
  'name': 'Clinic/Center, Public Health, Federal'
}, { 'id': '261QR0206X', 'name': 'Clinic/Center, Radiology, Mammography' }, {
  'id': '261QR0400X',
  'name': 'Clinic/Center, Rehabilitation'
}, { 'id': '261QR0405X', 'name': 'Clinic/Center, Rehabilitation, Substance Use Disorder' }, {
  'id': '261QS1000X',
  'name': 'Clinic/Center, Student Health'
}, { 'id': '281PC2000X', 'name': 'Chronic Disease Hospital, Children' }, {
  'id': '282NC2000X',
  'name': 'General Acute Care Hospital, Children'
}, { 'id': '282NR1301X', 'name': 'General Acute Care Hospital, Rural' }, {
  'id': '2865C1500X',
  'name': 'Military Hospital, Community Health'
}, {
  'id': '2865X1600X',
  'name': 'Military Hospital, Military General Acute Care Hospital. Operational (Transportable)'
}, { 'id': '106E00000X', 'name': 'Assistant Behavior Analyst' }, {
  'id': '106S00000X',
  'name': 'Behavior Technician'
}, { 'id': '1223D0004X', 'name': 'Dentist, Dentist Anesthesiologist' }, {
  'id': '1223X2210X',
  'name': 'Dentist, Orofacial Pain'
}, { 'id': '125J00000X', 'name': 'Dental Therapist' }, {
  'id': '125K00000X',
  'name': 'Advanced Practice Dental Therapist'
}, { 'id': '125Q00000X', 'name': 'Oral Medicinist' }, {
  'id': '133VN1101X',
  'name': 'Dietitian, Registered, Nutrition, Gerontological'
}, {
  'id': '133VN1201X',
  'name': 'Dietitian, Registered, Nutrition, Obesity and Weight Management'
}, { 'id': '133VN1301X', 'name': 'Dietitian, Registered, Nutrition, Oncology' }, {
  'id': '133VN1401X',
  'name': 'Dietitian, Registered, Nutrition, Pediatric Critical Care'
}, { 'id': '133VN1501X', 'name': 'Dietitian, Registered, Nutrition, Sports Dietetics' }, {
  'id': '175T00000X',
  'name': 'Peer Specialist'
}, { 'id': '1835C0205X', 'name': 'Pharmacist, Critical Care' }, {
  'id': '1835P0200X',
  'name': 'Pharmacist, Pediatrics'
}, { 'id': '1835P2201X', 'name': 'Pharmacist, Ambulatory Care' }, {
  'id': '207RA0001X',
  'name': 'Internal Medicine, Advanced Heart Failure and Transplant Cardiology'
}, { 'id': '207RA0002X', 'name': 'Internal Medicine, Adult Congenital Heart Disease' }, {
  'id': '207RH0005X',
  'name': 'Internal Medicine, Hypertension Specialist'
}, {
  'id': '207VF0040X',
  'name': 'Obstetrics & Gynecology, Female Pelvic Medicine and Reconstructive Surgery'
}, { 'id': '207WX0009X', 'name': 'Ophthalmology, Glaucoma Specialist' }, {
  'id': '207WX0107X',
  'name': 'Ophthalmology, Retina Specialist'
}, { 'id': '207WX0108X', 'name': 'Ophthalmology, Uveitis and Ocular Inflammatory Disease' }, {
  'id': '207WX0109X',
  'name': 'Ophthalmology, Neuro-ophthalmology'
}, {
  'id': '207WX0110X',
  'name': 'Ophthalmology, Pediatric Ophthalmology and Strabismus Specialist'
}, { 'id': '207WX0120X', 'name': 'Ophthalmology, Cornea and External Diseases Specialist' }, {
  'id': '207WX0200X',
  'name': 'Ophthalmology, Ophthalmic Plastic and Reconstructive Surgery'
}, { 'id': '207ZC0008X', 'name': 'Pathology, Clinical Informatics' }, {
  'id': '2080B0002X',
  'name': 'Pediatrics, Obesity Medicine'
}, { 'id': '2081P0301X', 'name': 'Physical Medicine & Rehabilitation, Brain Injury Medicine' }, {
  'id': '2083A0300X',
  'name': 'Preventive Medicine, Addiction Medicine'
}, { 'id': '2083B0002X', 'name': 'Preventive Medicine, Obesity Medicine' }, {
  'id': '2083C0008X',
  'name': 'Preventive Medicine, Clinical Informatics'
}, { 'id': '2084A2900X', 'name': 'Psychiatry & Neurology, Neurocritical Care' }, {
  'id': '2084B0040X',
  'name': 'Psychiatry & Neurology, Behavioral Neurology & Neuropsychiatry'
}, { 'id': '2084P0301X', 'name': 'Psychiatry & Neurology, Brain Injury Medicine' }, {
  'id': '2088F0040X',
  'name': 'Urology, Female Pelvic Medicine and Reconstructive Surgery'
}, { 'id': '224Y00000X', 'name': 'Clinical Exercise Physiologist' }, {
  'id': '226000000X',
  'name': 'Recreational Therapist Assistant'
}, { 'id': '246ZS0410X', 'name': 'Specialist/Technologist, Other, Surgical Technologist' }, {
  'id': '246ZX2200X',
  'name': 'Specialist/Technologist, Other, Orthopedic Assistant'
}, { 'id': '335G00000X', 'name': 'Medical Foods Supplier' }, { 'id': '405300000X', 'name': 'Prevention Professional' }]

const LIST_DIRECTORY_SPECIALTIES = [
  { label: 'Telehealth', value: 'Telehealth' },
  { label: 'inStoreClinic', value: 'inStoreClinic' },
  { label: 'Resident', value: 'Resident' },
  { label: 'NP', value: 'NP' },
  { label: 'PA', value: 'PA' },
  { label: 'Doctor', value: 'Doctor' },
  { label: 'MedReconciliation', value: 'MedReconciliation' }
]
const LIST_USE_CASES = [
  { label: 'PBMMedAdhr', value: 'PBMMedAdhr' },
  { label: 'GapsIncare', value: 'GapsIncare' },
  { label: 'AttAlert', value: 'AttAlert' },
  { label: 'PNLIMMUN', value: 'PNLIMMUN' },
  { label: 'RTBC', value: 'RTBC' },
  { label: 'BASICSAVE', value: 'BASICSAVE' },
  { label: 'ADVSAVE', value: 'ADVSAVE' }
]
const LIST_SERVICE_LEVELS = [
  { label: 'Eligibility', value: 'Eligibility' },
  { label: 'MedHistory', value: 'MedHistory' },
  { label: 'New', value: 'New' },
  { label: 'Refill', value: 'Refill' },
  { label: 'Change', value: 'Change' },
  { label: 'Cancel', value: 'Cancel' },
  { label: 'ControlledSubstance', value: 'ControlledSubstance' },
  { label: 'ePA', value: 'ePA' },
  { label: 'PatMedBenefitCheck', value: 'PatMedBenefitCheck' },
  // { label: 'PriorAuthStatus', value: 'PriorAuthStatus' },
  // { label: 'RxFill', value: 'RxFill' }
]
export default {
  LIST_SPECIALTY_CODE,
  LIST_DIRECTORY_SPECIALTIES,
  LIST_USE_CASES,
  LIST_SERVICE_LEVELS
}
